import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Accent } from './SectionHeading';
import { audience } from '../../data/content';

/** Section 11 — who it is for. */
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-18" data-mp="1y9oet2ffmpfz">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-19" data-mp="1t8hajdci08e2">
        <div className="text-center lg:text-left" data-id="element-20" data-mp="285rfs4yjsi1c">
          <h2 id="audience-heading" className="font-display text-[2.1rem] font-bold leading-[1.08] text-brand-charcoal sm:text-[2.75rem]" data-id="element-21" data-mp="284gecbskrmde">
            Brow Instructor <Accent data-id="element-22" data-mp="2h17f31i2npeb">Ready</Accent>™ Is For You If…
          </h2>
          <p className="mt-8 rounded-[18px] bg-brand-sage/60 px-6 py-5 font-display text-[1.45rem] font-bold leading-snug text-brand-charcoal" data-id="element-23" data-mp="2cysy6mxyqzpo">
            Built specifically for professionals who teach brows.
          </p>
        </div>

        <ul className="border-t border-brand-charcoal/12" role="list" data-id="element-24" data-mp="2lwd1e1fdz62x">
          {audience.map(item => <li key={item} className="flex items-start gap-4 border-b border-brand-charcoal/10 py-4 text-[15px] leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-25" data-mp="1sdx5rg28nppi">
              <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-brand-cta" data-id="element-26" data-mp="26bdif9b4ofpp">
                <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={2.75} aria-hidden="true" data-id="element-27" data-mp="2bayftfangg0b" />
              </span>
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}